<template>
  <div class="validate">
    <div class="validate__title">{{ $t('validate.titles.page') }}</div>
    <div class="validate__content" v-if="!isLoading">
      <transition name="fade" mode="out-in">
        <el-card class="validate__card cancel-infos-card" v-if="cancelStatus">
          <span class="bold">{{$t('validate.cancelInfos')}}</span>
        </el-card>
      </transition>
      <estimation-price
        class="validate__card"
        :estimation-results="price"
        @nextButtonClick="onNextButtonClick"
      />
      <el-card class="validate__card">
        <trustpilot
          template="5406e65db0d04a09e042d5fc"
          height="28px"
          theme="light"
        />
      </el-card>
      <address-card
        class="validate__card"
        :title="$t('validate.titles.loading')"
        :housing-type="getHousingName(loading.floor.type_logement)"
        :floor="loading.floor.floor"
        :lift="loading.floor.lift"
        :lift-comment="loading.floor.lift_comment"
        :vl="loading.parking.vl ? true : false"
        :portage="loading.parking.portage"
        :address="loadingAddress"
        :date="dateString"
        :display-access="!isSpecialAddress(loading.floor.type_logement)"
        :title-icon="['fal', 'home-lg-alt']"
      />
      <address-card
        class="validate__card"
        :title="$t('validate.titles.delivery')"
        :housing-type="getHousingName(delivery.floor.type_logement)"
        :floor="delivery.floor.floor"
        :lift="delivery.floor.lift"
        :lift-comment="delivery.floor.lift_comment"
        :vl="delivery.parking.vl ? true : false"
        :portage="delivery.parking.portage"
        :address="deliveryAddress"
        :date="dateString"
        :display-access="isKnownAddress
          && !isSpecialAddress(delivery.floor.type_logement)"
      />
      <formula-and-service-card class="validate__card" :formula-and-service="service"/>
    </div>
    <div class="loading" v-else>
      <Loader />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AddressCard from '@/components/validate/AddressCard.vue';
import Loader from '@/components/utils/Loader.vue';
import { FIX_DATE } from '@/store/modules/serviceOfferStore';
import Formatter from '@/utils/helpers/format';
import { Connector } from '@/backendConnector';
import EstimationPrice from '@/components/validate/EstimationPrice.vue';
import FormulaAndServiceCard from '@/components/validate/FormulaAndServiceCard.vue';
import Trustpilot from '@/components/utils/Trustpilot.vue';

import { isSpecialLogementType } from '@/store/utils';


export default {
  name: 'Confirm',
  components: {
    FormulaAndServiceCard,
    AddressCard,
    EstimationPrice,
    Loader,
    Trustpilot,
  },
  computed: {
    loadingAddress() {
      return [{ title: this.$t('validate.titles.loading'), address: this.$store.getters['loadingStore/address'] }];
    },
    deliveryAddress() {
      return [{ title: this.$t('validate.titles.delivery'), address: this.$store.getters['deliveryStore/address'] }];
    },
    ...mapGetters({
      loading: 'loadingStore/loading',
      delivery: 'deliveryStore/delivery',
      dates: 'serviceOfferStore/dates',
      isKnownAddress: 'deliveryStore/isAddressKnown',
      cancelStatus: 'projectStore/cancelStatus',
    }),
    dateString() {
      if (this.dates[0].chosen_by_client === FIX_DATE) {
        return Formatter.formatDate(new Date(this.dates[0].date_first));
      }
      return `${Formatter.formatDate(new Date(this.dates[0].date_first))}
         - ${Formatter.formatDate(new Date(this.dates[0].date_last))}`;
    },
  },
  methods: {
    getHousingName(type) {
      switch (type) {
        case 'DGTS_LOG_APPART':
          return this.$t('housing.type_logement.options.apartment');
        case 'DGTS_LOG_MAISON':
          return this.$t('housing.type_logement.options.house');
        case 'DGTS_LOG_DUPLEX':
          return this.$t('housing.type_logement.options.duplex');
        case 'DGTS_LOG_TRIPLEX':
          return this.$t('housing.type_logement.options.triplex');
        case 'DGTS_LOG_GARDEMEUBLE':
          return this.$t('housing.type_logement.options.garde_meuble');
        default:
          return this.$t('housing.type_logement.options.other');
      }
    },
    isSpecialAddress(type) {
      return isSpecialLogementType(type);
    },
    onNextButtonClick() {
      const nextButton = document.getElementById('next-button');
      nextButton.click();
    },
  },
  data() {
    return {
      price: {},
      service: {},
      isLoading: true,
    };
  },
  mounted() {
    const estimation = Connector.getInstance().getEstimationResults();
    const formulaAndService = Connector.getInstance().getFormulaAndService();
    Promise.all([estimation, formulaAndService]).then(([estim, services]) => {
      this.price = estim;
      this.service = services;
      this.isLoading = false;
    });
  },
};
</script>

<style scoped lang="scss">
  .validate {
    margin-bottom: 20px;
    &__title {
      margin: 16px 0;
      font-weight: $--font-weight-600;
      font-size: $--font-size-large;
    }
    &__card{
      margin-bottom: 10px;
    }
    .loading {
      position: absolute;
      top: 0;
      left: 0;
    }
    .cancel-infos-card {
      color: $--color-secondary;
      font-size: 16px;
      @include breakpoint(mobile) {
        font-size: 19px;
      }
      background-color: $--color-primary;
    }
  }
  .fade {
    &-enter-active, &-leave-active {
      transition: opacity 200ms;
    }

    &-enter, &-leave-to {
      opacity: 0;
    }
  }
</style>
